<template>
  <!--begin::Wrapper-->
  <div class="w-100">
    <!--begin::Input group-->
    <div class="fv-row">
      <div class="row">
        <!-- código único file -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Código único file PPL:</label>
          <Field
            name="codigo_unico"
            v-slot="{ field }"
            v-model="formData.codigo_unico"
          >
            <input
              v-bind="field"
              type="text"
              class="form-control fuente"
              style="text-transform: uppercase"
              id="cod_unico"
            />
          </Field>
          <ErrorMessage
            name="codigo_unico"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- estado_civil -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Estado civil:</label>
          <Field
            name="estado_civil"
            v-slot="{ field }"
            v-model="formData.estado_civil"
          >
            <select
              v-model="formData.estado_civil"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in civilStatusList"
                :value="list.id_estado_civil"
                :key="key"
              >
                {{ list.nombre_estado_civil }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="estado_civil"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- id_etnica -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Identificación Étnica:</label>
          <Field
            name="identificacion_etnica"
            v-slot="{ field }"
            v-model="formData.identificacion_etnica"
          >
            <select
              v-model="formData.identificacion_etnica"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in ethnicIdentificationList"
                :value="list.id_identificacion_etnica"
                :key="key"
              >
                {{ list.nombre_identificacion_etnica }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="identificacion_etnica"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- idioma_primario -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Idioma primario:</label>
          <Field
            name="idioma_primario"
            v-slot="{ field }"
            v-model="formData.idioma_primario"
          >
            <select
              v-model="formData.idioma_primario"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in languageList"
                :value="list.id_idioma"
                :key="key"
              >
                {{ list.nombre_idioma }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="idioma_primario"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- idioma_secundario -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Idioma secundario:</label>
          <Field
            name="idioma_secundario"
            v-slot="{ field }"
            v-model="formData.idioma_secundario"
          >
            <select
              v-model="formData.idioma_secundario"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in languageList"
                :value="list.id_idioma"
                :key="key"
                :disabled="formData.idioma_primario === list.id_idioma"
              >
                {{ list.nombre_idioma }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="idioma_secundario"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- orientacion_sexual -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Orientación sexual:</label>
          <Field
            name="orientacion_sexual"
            v-slot="{ field }"
            v-model="formData.orientacion_sexual"
          >
            <select
              v-model="formData.orientacion_sexual"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in sexualOrientationList"
                :value="list.id_orientacion_sexual"
                :key="key"
              >
                {{ list.nombre_orientacion_sexual }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="orientacion_sexual"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- religion -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Religión:</label>
          <Field name="religion" v-slot="{ field }" v-model="formData.religion">
            <select
              v-model="formData.religion"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in religionList"
                :value="list.id_religion"
                :key="key"
              >
                {{ list.nombre_religion }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="religion"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- profesion -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Profesión:</label>
          <Field
            name="profesion"
            v-slot="{ field }"
            v-model="formData.profesion"
          >
            <select
              v-model="formData.profesion"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in professionList"
                :value="list.id_grado_profesion"
                :key="key"
              >
                {{ list.nombre_grado_profesion }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="profesion"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- oficio -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Oficio:</label>
          <Field name="oficio" v-slot="{ field }" v-model="formData.oficio">
            <select
              v-model="formData.oficio"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in jobList"
                :value="list.id_oficio"
                :key="key"
              >
                {{ list.nombre_oficio }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="oficio"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- grado_instruccion -->
        <div class="col-md-4 mt-3">
          <label class="form-label required">Grado de instrucción:</label>
          <Field
            name="grado_instruccion"
            v-slot="{ field }"
            v-model="formData.grado_instruccion"
          >
            <select
              v-model="formData.grado_instruccion"
              class="form-select fuente"
              aria-label="select"
              v-bind="field"
              style="text-transform: uppercase"
            >
              <option
                v-for="(list, key) in degreeInstructionList"
                :value="list.id_grado_instruccion"
                :key="key"
              >
                {{ list.nombre_grado_instruccion }}
              </option>
            </select>
          </Field>
          <ErrorMessage
            name="grado_instruccion"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
        <!-- observacion -->
        <div class="col-md-8 mt-3">
          <label class="form-label">Observaciones:</label>
          <Field
            name="observacionGenerales"
            v-slot="{ field }"
            v-model="formData.observacionGenerales"
          >
            <textarea
              v-bind="field"
              class="form-control fuente"
              id="telefonoCelular"
              min="1"
              pattern="^[0-9]+"
              style="text-transform: uppercase"
              v-model="formData.observacionGenerales"
            />
          </Field>
          <ErrorMessage
            name="observacionGenerales"
            class="fv-plugins-message-container invalid-feedback"
          ></ErrorMessage>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  defineComponent,
  ref,
  onMounted,
  reactive,
  computed,
  onBeforeUpdate,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { Field, ErrorMessage } from "vee-validate";
import filiation from "@/filiation/composables/useFiliation";
import "vue-select/dist/vue-select.css";
import { useRoute } from "vue-router";
export default defineComponent({
  name: "generalData",
  components: {
    //vSelect,
    //Datepicker,
    Field,
    ErrorMessage,
    //Loading,
  },
  setup() {
    const route = useRoute();
    const disabled = ref(false);
    const civilStatusList = ref([]);
    const ethnicIdentificationList = ref([]);
    const languageList = ref([]);
    const sexualOrientationList = ref([]);
    const religionList = ref([]);
    const professionList = ref([]);
    const jobList = ref([]);
    const degreeInstructionList = ref([]);
    const formData = reactive({
      codigo_unico: "",
      estado_civil: "",
      identificacion_etnica: "",
      idioma_primario: "",
      idioma_secundario: null,
      orientacion_sexual: "",
      religion: "",
      profesion: "",
      oficio: "",
      grado_instruccion: "",
      observacionGenerales: "",
    });
    const {
      civilStatus,
      ethnicIdentification,
      languages,
      sexual_orientation,
      religions,
      professions,
      jobs,
      degreeInstructions,
      dataToEdit,
    } = filiation();
    const cStatus = async () => {
      const { data } = await civilStatus();
      civilStatusList.value = data;
    };
    const ethnic_id = async () => {
      const { data } = await ethnicIdentification();
      ethnicIdentificationList.value = data;
    };
    const language = async () => {
      const { data } = await languages();
      languageList.value = data;
    };
    const sex_orientation = async () => {
      const { data } = await sexual_orientation();
      sexualOrientationList.value = data;
    };
    const religion = async () => {
      const { data } = await religions();
      religionList.value = data;
    };
    const profession = async () => {
      const { data } = await professions();
      professionList.value = data;
    };
    const job = async () => {
      const { data } = await jobs();
      jobList.value = data;
    };
    const degreeInstruction = async () => {
      const { data } = await degreeInstructions();
      degreeInstructionList.value = data;
    };
    const dataEdit = computed(() => dataToEdit.value);
    const personDetails = computed(() => route.params.id_persona);
    const orderDetails = computed(() => route.params.id_orden_judicial);
    const edit = () => {
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        disabled.value = true;
        formData.codigo_unico = dataEdit.value.data.general[0].codigo_file_ppl;
        formData.estado_civil = dataEdit.value.data.general[0].cod_estado_civil;
        formData.identificacion_etnica= dataEdit.value.data.general[0].cod_identificacion_etnica;
        formData.idioma_primario = dataEdit.value.data.general[0].idioma_primario;
        formData.idioma_secundario = dataEdit.value.data.general[0].idioma_secundario;
        formData.orientacion_sexual = dataEdit.value.data.general[0].cod_orientacion_sexual;
        formData.religion = dataEdit.value.data.general[0].cod_religion;
        formData.profesion = dataEdit.value.data.general[0].cod_profesion;
        formData.oficio = dataEdit.value.data.general[0].cod_oficio;
        formData.grado_instruccion = dataEdit.value.data.general[0].cod_grado_instruccion;
        formData.observacionGenerales = dataEdit.value.data.general[0].obs_generales;
      }
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Datos generales", [
        "Registro privado de libertad",
      ]);
      cStatus();
      ethnic_id();
      language();
      sex_orientation();
      religion();
      profession();
      job();
      degreeInstruction();
      if (personDetails.value !== "0" && orderDetails.value !== "0") {
        const data = JSON.parse(localStorage.getItem("edit") || "{}");
        disabled.value = true;
        formData.codigo_unico = data.general[0].codigo_file_ppl;
        formData.estado_civil = data.general[0].cod_estado_civil;
        formData.identificacion_etnica = data.general[0].cod_identificacion_etnica;
        formData.idioma_primario = data.general[0].idioma_primario;
        formData.idioma_secundario = data.general[0].idioma_secundario;
        formData.orientacion_sexual = data.general[0].cod_orientacion_sexual;
        formData.religion = data.general[0].cod_religion;
        formData.profesion = data.general[0].cod_profesion;
        formData.oficio = data.general[0].cod_oficio;
        formData.grado_instruccion = data.general[0].cod_grado_instruccion;
        formData.observacionGenerales = data.general[0].obs_generales;
      }
    });
    return {
      formData,
      civilStatusList,
      ethnicIdentificationList,
      languageList,
      sexualOrientationList,
      religionList,
      professionList,
      jobList,
      degreeInstructionList,
      disabled,
      dataEdit,
    };
  },
});
</script>
<style>
.fuente {
  font-size: 0.97em;
  padding: 0.35em;
  font-weight: normal;
}
textarea {
  width: 200px;
  height: 80px;
}
</style>
